import {
  CardContent,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { isThisMinute } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import StyledTableRow from "../../components/StyledTableRow";
import {
  convertToThousands,
  getUniqueValues,
  _isNaN,
  countOrACVFormatter,
} from "../../util/customFunctions";
import * as d3 from "d3";
import { getMixKey } from "../../util/generateHeadings";
import {
  customSortedOppType,
  customSortedSegments,
} from "../../util/customSortings";
import { deSnake } from "../../util/dataFormatter";
import { color } from "d3";
import CopyTablesObject from "../../components/xlsx-export/CopyTablesObject";
import stickytableStyle from "../../StickyTableStyles/Sticky_Table_Styles";
// import ExcelExportButton from "../../components/xlsx-export/xlsxexport";

const useStyle = makeStyles((theme) => ({
  root: {},
  // sticky: {
  //   position: "sticky",
  //   left: -1,
  //   // color: "inherit",
  //   background: "white",
  //   // backgroundColor: "inherit",
  //   // boxShadow: "5px 2px 5px grey",
  //   // borderRight: "2px solid black",
  // },
  content: { width: "100%" },
  table: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  repText: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "left",
    minWidth: "169px",
    fontWeight: "inherit",
  },
  repNumber: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    fontWeight: "inherit",
  },
  repNumberACV: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    minWidth: "92px",
    fontWeight: "inherit",
  },
  repNumberPercent: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    minWidth: "90px",
    fontWeight: 600,
    cursor: "pointer",
  },
  repTextH: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "left",
    fontWeight: 600,
  },
  repNumberH: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    fontWeight: 600,
  },
  tableHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  repHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    width: "5%",
  },
  inner: {
    height: 375,
    minWidth: 500,
  },
  chart: {
    height: "100%",
  },
  tableHeader: {
    fontSize: "15px",
    whiteSpace: "normal",
    textAlign: "center",
  },
  tableCell: {
    whiteSpace: "normal",
  },
  indentName: {
    paddingLeft: 30,
  },
  blackLabel: {
    color: "black",
  },
  inputFieldContainers: {
    marginBottom: 10,
    padding: 10,
    [theme.breakpoints.up("lg")]: {
      paddingRight: 0,
    },
  },
  fontBold: {
    fontWeight: 600,
  },
  stickyColumn: {
    minWidth: 200,
    left: 0,
    position: "sticky",
    zIndex: theme.zIndex.appBar + 1,
  },
}));
export default function GoLiveTable(props) {
  const classes = useStyle();
  const stickyClasses = stickytableStyle();
  const tableRef = React.createRef();
  const tableContainerRef = useRef();

  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  let totalindex;



  const attainmentThreshold = props.Threshold > 0 ? props.Threshold / 100 : 0;
  console.log(attainmentThreshold);

  // const uniqueQuarters = quarter.map(item => item[props.quarters]).filter(getUniqueValues)
  const uniqueQuarters = props.data.map(item => item['month']).filter(getUniqueValues);

  const uniqueAttainment = props.data
    .filter((item) => item['month'] === "Total")
    .sort((a, b) =>
      b.perc === a.perc
        ? b.actual - a.actual
        : b.perc - a.perc
    );

    const uniqueTeams = uniqueAttainment.filter(f => f.team !== 'Total')
    .map((item) => item.team)
    .filter(getUniqueValues)
    .filter((item) => item !== null);

  let uniqueOwner = uniqueAttainment.filter(f => f.rep !== 'Total')
    .map((item) => item.rep)
    .filter(getUniqueValues)
    .filter((item) => item !== null);
  uniqueOwner =
    props.toggleValue === "PercSort" ? [...uniqueOwner] : [...uniqueOwner.sort()];




  useEffect(() => {
    const tableContainer = document.getElementById("myTableContainer-three");

    const handleOverflowCheck = () => {
      if (tableContainer) {
        setIsOverflowing(
          tableContainer.scrollWidth > tableContainer.offsetWidth
        );
      }
    };

    // Check for overflow initially and whenever the component updates
    handleOverflowCheck();

    // Attach a resize event listener to check for overflow when the window is resized
    window.addEventListener("resize", handleOverflowCheck);

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener("resize", handleOverflowCheck);
    };
  }, []);

  useEffect(() => {
    const tableContainer = tableContainerRef.current;

    const handleScroll = () => {
      if (tableContainer.scrollLeft > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    // Attach a scroll event listener to the TableContainer
    tableContainer.addEventListener("scroll", handleScroll);

    return () => {
      // Clean up the event listener when the component unmounts
      tableContainer.removeEventListener("scroll", handleScroll);
    };
  }, [stickyClasses.sticky]);
  return (
    <div
      className={classes.root}
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <CardContent className={classes.content} style={{ padding: "1rem" }}>
        {isOverflowing ? (
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginBottom: "10px",
              // marginRight: "10px",
            }}
          >
            <CopyTablesObject tableRef={tableRef} />
          </div>
        ) : null}
        <Grid container justify="flex-start" style={{ padding: "1rem" }}>
          <TableContainer
            className={classes.mainTable}
            id="myTableContainer-three"
            ref={tableContainerRef}
            style={{ borderLeft: isSticky ? "0.5px solid lightgrey" : "" }}
          >
            {isOverflowing === false ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "10px",
                  // marginRight: "10px",
                }}
              >
                <CopyTablesObject tableRef={tableRef} />
              </div>
            ) : null}
            <Table
              ref={tableRef}
              size="small"
              aria-label="html table"
              style={{ tableLayout: "auto", width: "initial" }}
              data-test="quota-attainment-detail-threshold-table"
            >
              <TableHead>
                <TableRow style={{ fontWeight: 600, paddingLeft: 5 }}>
                  <TableCell
                    align="center"
                    // className={`${classes.repHeader}`}
                    className={
                      isSticky
                        ? `${stickyClasses.sticky} ${classes.repHeader}`
                        : classes.repHeader
                    }
                    colSpan={1}
                    style={{ minWidth: 150 }}
                  >
                    {props.selectedTimeFrame}
                  </TableCell>
                  {uniqueQuarters.map((i, index) => {
                    return (
                      <TableCell
                        key={i}
                        align="center"
                        style={
                          index % 2 === 0
                            ? { background: "#4471c4", color: "white" }
                            : {
                                background: "#5b9bd5",
                                color: "white",
                                padding: "10px 0",
                              }
                        }
                        className={classes.repHeader}
                        colSpan={4}
                      >
                        {i}
                      </TableCell>
                    );
                  })}
                  

                  {uniqueQuarters.length === 0 && (
                    <TableCell
                      rowSpan={8}
                      className={classes.repHeader}
                      style={{ width: 400, textAlign: "center" }}
                    >
                      No data available
                    </TableCell>
                  )}
                </TableRow>
                <TableRow style={{ fontWeight: 600, paddingLeft: 5 }}>
                  <TableCell
                    align="center"
                    // className={`${classes.repHeader}`}
                    className={
                      isSticky
                        ? `${stickyClasses.sticky} ${classes.repHeader}`
                        : classes.repHeader
                    }
                    colSpan={1}
                  >
                    {"Rep"}
                  </TableCell>
                  {uniqueQuarters.map((i) => {
                    return (
                      <React.Fragment key={i}>
                        <TableCell
                          align="center"
                          className={classes.repHeader}
                          colSpan={1}
                        >{`Go Live Goal`}</TableCell>
                        <TableCell
                          align="center"
                          className={classes.repHeader}
                          colSpan={1}
                        >
                          {"Goal"}
                        </TableCell>
                        <TableCell
                          align="center"
                          className={classes.repHeader}
                          colSpan={1}
                        >{`Actual`}</TableCell>
                        <TableCell
                          align="center"
                          className={classes.repHeader}
                          colSpan={1}
                        >{`Attain. %`}</TableCell>
                      </React.Fragment>
                    );
                  })}
                  
                </TableRow>
              </TableHead>
              <TableBody>
                {uniqueOwner.map((rep, i) => {
                  totalindex = i + 1;
                  const repData = props.data
                    .filter(
                      (item) =>
                        item['rep'] === rep 
                    )
                  // const teamForDrilldown = props.groupby === 'Team' ? team : props.data.filter(item=> item[props.groupbyColumn] === team).map(c => c.team)[0]
                  // const reps = props.data.filter(item =>  item[props.groupbyColumn] === team && (!["team","total"].includes(item.Owner_Name))).sort((a, b) => b.attainment === a.attainment ? b.acv - a.acv : b.attainment - a.attainment).map(item=> item.Owner_Name).filter(getUniqueValues)
              
                  return (
                    <>
                      {" "}
                      <StyledTableRow key={i}>
                        <TableCell
                          align="left"
                          // className={`${classes.table} ${classes.repHeader}`}
                          className={
                            isSticky
                              ? `${stickyClasses.sticky} ${classes.table} ${classes.repHeader}}`
                              : `${classes.table} ${classes.repHeader}`
                          }
                          style={
                            isSticky && i % 2 === 1
                              ? { background: "#f5f5f5", fontWeight: 600 }
                              : { fontWeight: 600 }
                          }
                          colSpan={1}
                        >
                          {rep}
                        </TableCell>

                        {uniqueQuarters.map((qtr, j) => {
                          const repsData = repData.filter(
                            (item) =>
                              item['month'] === qtr &&
                              item['rep'] === rep
                          );
                          // console.log(props.data.filter(item => item.Owner_Name === owner).map(item => item.Quota)[0] === 0)
                         
                          const actual = countOrACVFormatter(repsData
                            .reduce((a,b) => a+b.actual, 0), true);
                          const attainment = `${Math.round(repsData
                          .reduce((a,b) => a+b.perc, 0) * 100)}%`
                          const goal = countOrACVFormatter(repsData
                          .reduce((a,b) => a+b.goal, 0), true);
                          const goLiveGoal = (qtr === 'Total' || rep === 'Total') ? '' : `${Math.round(repsData
                            .reduce((a,b) => a+b.goLiveGoal, 0) * 100)}%`
                          return (
                            <>
                              <TableCell
                                align="right"
                                className={classes.repHeader}
                                colSpan={1}
                              >
                                {goLiveGoal}
                              </TableCell>
                              <TableCell
                                align="right"
                                className={classes.repHeader}
                                colSpan={1}
                              >
                                {goal}
                              </TableCell>
                              <TableCell
                                align="right"
                                className={classes.repHeader}
                                colSpan={1}
                                style={{cursor: 'pointer'}}
                                onClick={() =>
                                    props.handleChangeLocation(
                                      "drilldownOnGraph3",
                                      {
                                        row: rep === 'Total' ? uniqueOwner.filter(f => f !== 'Total') : rep,
                                        cell: qtr === 'Total' ? uniqueQuarters.filter(f => f!== 'Total') : qtr ,
                                      },
                                      undefined,
                                      props.selectedTimeFrame
                                    )
                                  }
                              >
                                {actual}
                              </TableCell>
                              <TableCell
                                align="right"
                                className={classes.repHeader}
                                colSpan={1}
                              >
                                {attainment}
                              </TableCell>
                            </>
                          );
                        })}

                     
                      </StyledTableRow>
                    </>
                  );
                })}

              

             
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

      
      </CardContent>
    </div>
  );
}
